
// Security utilities for the frontend

/**
 * CSP Report Handler - Log CSP violations for monitoring
 */
export const handleCSPReport = (report) => {
  // In production, send to your logging service
  console.warn('CSP Violation:', report);
  
  // Example: Send to analytics or logging service
  // fetch('/api/csp-report', {
  //   method: 'POST',
  //   headers: { 'Content-Type': 'application/json' },
  //   body: JSON.stringify(report)
  // });
};

/**
 * Sanitize user input to prevent XSS
 */
export const sanitizeInput = (input) => {
  if (typeof input !== 'string') return input;
  
  return input
    .replace(/[<>]/g, '') // Remove angle brackets
    .replace(/javascript:/gi, '') // Remove javascript: protocol
    .replace(/on\w+=/gi, '') // Remove event handlers
    .trim();
};

/**
 * Validate URLs to prevent open redirects
 */
export const isValidURL = (url) => {
  try {
    const parsed = new URL(url, window.location.origin);
    // Only allow same origin or trusted domains
    const trustedDomains = [
      'trbe.com',
      'jobs.trbe.ai',
      'quest-media-storage-bucket.s3.us-east-2.amazonaws.com'
    ];
    
    return trustedDomains.some(domain => 
      parsed.hostname === domain || parsed.hostname.endsWith('.' + domain)
    ) || parsed.origin === window.location.origin;
  } catch {
    return false;
  }
};

/**
 * Set secure cookie defaults
 */
export const setSecureCookie = (name, value, options = {}) => {
  const secureOptions = {
    secure: window.location.protocol === 'https:',
    sameSite: 'Strict',
    httpOnly: false, // Can't set httpOnly from JS
    ...options
  };
  
  let cookieString = `${name}=${value}`;
  
  if (secureOptions.maxAge) {
    cookieString += `; Max-Age=${secureOptions.maxAge}`;
  }
  
  if (secureOptions.secure) {
    cookieString += '; Secure';
  }
  
  cookieString += `; SameSite=${secureOptions.sameSite}`;
  
  document.cookie = cookieString;
};
